module.exports = __webpack_public_path__ + "static/media/huoyanshan_package.22f78012.png";